import { useSearchParams } from 'react-router-dom';
import UnbilledUsage from '../../components/unbilled/UnbilledUsage';

export const MyUsage = () => {
  const [params] = useSearchParams();

  return <UnbilledUsage searchNumber={params.get('search')} />;
};
